import React from 'react';
import {Route, Routes} from "react-router-dom";
import Layout from "../Layout/Layout";
import AdminGuard from "../LayoutAdmin/AdminGuard";
import Login from "../LayoutAdmin/Login/Login";
import LayoutAdmin from "../LayoutAdmin/LayoutAdmin";




const AppRouter = () => {
    return (
        <Routes>

            {/* Site public */}
            <Route path="/" element={<Layout/>} />

            {/* admin */}
            <Route path="/admin/login" element={<Login/>} />
            <Route path="/admin/*" element={
                <AdminGuard>
                    <Routes>
                        <Route path="dashboard" element={<LayoutAdmin />} />
                    </Routes>
                </AdminGuard>
            } />
        </Routes>

    );
};

export default AppRouter;
